import React, { useContext } from "react";
import { Link } from "react-router-dom";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";

import { StaticListingList, Money } from "../../components";
import { useCart } from "../cartState";
import { UserContext } from "../../contexts";
import { getBaseCurrency, orderItemCurrency } from "../../core/currency";

export function Cart() {
  const cart = useCart();

  const toggleCart = (e) => {
    e.preventDefault();
    cart.toggle();
  };
  const user = useContext(UserContext);

  // `cart.total` is Σ item.price with NO conversion (cartState), so it may only
  // be labelled with the currency those items are in. It was labelled with the
  // store base — a different record's currency — which stamps the base symbol
  // onto a foreign amount the moment a listing isn't priced in the base.
  // Mixed-currency carts are rejected by the backend (OrderValidationService),
  // so one sole currency is the only valid case; an empty or genuinely mixed
  // cart keeps the previous store-base render rather than picking one arbitrarily.
  const cartCurrencies = new Set(
    (cart.items ?? []).map((item) => orderItemCurrency(item, item.listing))
  );
  const cartCurrency =
    cartCurrencies.size === 1 ? [...cartCurrencies][0] : getBaseCurrency();

  return (
    <SlidingPane
      className="cart-sliding-pane"
      isOpen={cart.isVisible}
      hideHeader={true}
      shouldCloseOnEsc={true}
      title="Shopping Cart"
      from="right"
      onRequestClose={() => cart.hide()}
    >
      <div id="cart">
        <div className="d-flex header">
          <div className="flex-grow-1">
            <h2>Shopping Cart</h2>
          </div>

          <a href="#" onClick={toggleCart} className="align-self-center">
            <img src="/assets/icons/close.png" height="16" width="16" />
          </a>
        </div>

        {cart.count > 0 && (
          <>
            <StaticListingList cart={cart} />

            {cart.total > 0 && (
              <div className="total d-flex justify-content-between">
                <span className="align-self-center">Cart Total:</span>
                <Money
                  className="align-self-center amount"
                  amount={cart.total}
                  currency={cartCurrency}
                />
              </div>
            )}

            <div className="actions">
              {user ? (
                <Link to="/checkout" onClick={() => cart.hide()}>
                  <button>Complete Purchase</button>
                </Link>
              ) : (
                <Link to="/sign-in" onClick={() => cart.hide()}>
                  <button>Sign In</button>
                </Link>
              )}
            </div>
          </>
        )}

        {cart.count === 0 && (
          <div className="empty">
            <h3>Your shopping bag is currently empty</h3>

            <p className="mt-2 mb-5">
              Make it feel needed by adding some nice products.
            </p>

            <Link to="/products">
              <button>Start Shopping</button>
            </Link>
          </div>
        )}
      </div>
    </SlidingPane>
  );
}
